/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { BulkDeleteVisitsErrorReasonEnumType } from "./BulkDeleteVisitsErrorReasonEnum"
import { RootStoreType } from "./index"


/**
 * BulkDeleteVisitsErrorDtoBase
 * auto generated base class for the model BulkDeleteVisitsErrorDtoModel.
 */
export const BulkDeleteVisitsErrorDtoModelBase = ModelBase
  .named('BulkDeleteVisitsErrorDto')
  .props({
    __typename: types.optional(types.literal("BulkDeleteVisitsErrorDto"), "BulkDeleteVisitsErrorDto"),
    uuid: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, BulkDeleteVisitsErrorReasonEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BulkDeleteVisitsErrorDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromBulkDeleteVisitsErrorDto() {
  return new BulkDeleteVisitsErrorDtoModelSelector()
}

export const bulkDeleteVisitsErrorDtoModelPrimitives = selectFromBulkDeleteVisitsErrorDto().uuid.reason
